<ion-header class="ion-justify-content-center ion-align-items-center">
  <ion-toolbar>
  <img class="logo" src="/assets/img/logo-60.png"  style="margin-left: 15px; margin-top: 8px;" width="134px" alt="">
</ion-toolbar>
</ion-header>
<ion-content class="offline-page" scroll="false">
  <ion-grid class="ion-text-center offline-wrapper">
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size="12">
        <ion-img src="/assets/img/no-internet.svg" style="max-width: 200px; margin: auto;"></ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <ion-text color="medium">
          <h2>No Internet Connection</h2>
        </ion-text>
        <p>Please check your connection and try again.</p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>